export default function cloudflareLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality: number;
}) {
  if (src.startsWith("http")) {
    return src;
  }

  const params = ["format=auto"];

  if (width) {
    params.push(`width=${width}`);
  } else {
    params.push("width=auto");
  }

  if (quality) {
    params.push(`quality=${quality}`);
  }

  const paramString = params.join(",");

  return `${process.env.NEXT_PUBLIC_MEDIA_URL}/${src}/${paramString}`;
}
